import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FeedService } from '../../services/feed.service';
import { LoginService } from 'src/app/core/services/login.service';
import { PostnewJob } from 'src/app/modules/profile/services/job-section.service';
import { ToastService } from 'src/app/core/toast.service';
import { Tables } from 'src/app/shared/enum/tables.enum';
import { CommonServicesForAllModules } from 'src/app/shared/common/service';

@Component({
  selector: 'app-add-employee-type',
  templateUrl: './add-employee-type.component.html',
  styleUrls: ['./add-employee-type.component.scss']
})
export class AddEmployeeTypeComponent implements OnInit {
  employeeTypeForm: FormGroup;
  employeeTypeId: string | null = null;
  employeeTypeName: any;
  constructor(private route: ActivatedRoute, private fb: FormBuilder, private router: Router, public feedService: FeedService, public loginService: LoginService,private jobService: PostnewJob, private toast: ToastService ,private commonService:CommonServicesForAllModules) {
    this.employeeTypeForm = this.fb.group({
      employee_type_name: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['employeeTypeName']) {
        this.employeeTypeForm.patchValue({ employee_type_name: params['employeeTypeName'] });
      }
    });
    this.route.paramMap.subscribe(params => {
      this.employeeTypeId = params.get('id');
      // if (this.employeeTypeId) {
      //   this.loadCategoryDetails();
      // }
    });

  }
  // loadCategoryDetails() { }

  async onSubmit(): Promise<void> {
    if (this.employeeTypeForm.invalid) {
      this.employeeTypeForm.markAllAsTouched();  // This will show error messages
      return;  
    }

    const loginData = this.loginService.getLoginData();


    if (!loginData) {
      console.error('Login data is not available');
      return;
    }
    const employeeTypeData = {
      ...this.employeeTypeForm.value,
      created_by: loginData.type,
      created_by_user_id: loginData.id
    };

    try {
      if (this.employeeTypeId) {
        // Update existing employee type
        await this.commonService.UpdateData(Tables.Job_Types,this.employeeTypeId,{employee_type_name: employeeTypeData.employee_type_name });
        this.toast.openSnackBar('Employee Type updated successfully');
      } else {
        // Insert new employee type
        await this.commonService.InsertData(Tables.Job_Types, employeeTypeData);
        this.toast.openSnackBar('Employee Type added successfully');
      }
      this.router.navigate(['/profile/list-employee-type']);
    } catch (error) {
      console.error('Error occurred while saving Employee Type:', error);
      this.toast.openSnackBar('Failed to save Employee Type');
    }
  }


  onCancel(): void {
    this.router.navigate(['/profile/list-employee-type']);
  }
}